/**
 * @file OrderItemsToolbar.tsx
 * @description Шапка вкладки «Позиции»: заголовок, объяснение заморозки и
 * кнопки режима правки (phase19.15 шаг 4).
 *
 * Вынесено из `OrderItemsTab`, чтобы вкладка осталась в пределах 200 строк и
 * занималась только данными: тулбар ничего не грузит и не мутирует.
 */

import { Pencil, Plus, X } from "lucide-react";

import { Button } from "../ui/button";

interface Props {
  /** Правка разрешена: право менеджера + состояние заказа. */
  canEdit: boolean;
  editing: boolean;
  /** Идёт запрос — кнопки блокируются. */
  busy: boolean;
  /** Почему состав заморожен; `null` — править можно. */
  lockMessage: string | null;
  onToggleEditing: () => void;
  onAdd: () => void;
}

export function OrderItemsToolbar({
  canEdit,
  editing,
  busy,
  lockMessage,
  onToggleEditing,
  onAdd,
}: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="min-w-0">
        <div className="label-editorial">Состав заказа</div>
        {lockMessage ? (
          <p className="mt-0.5 text-sm text-on-surface-variant">{lockMessage}</p>
        ) : null}
      </div>
      {canEdit ? (
        <div className="flex flex-wrap gap-2">
          {editing ? (
            <Button variant="outline" className="min-h-12" onClick={onAdd} disabled={busy}>
              <Plus className="mr-1 size-4" />
              Добавить позицию
            </Button>
          ) : null}
          <Button
            variant={editing ? "ghost" : "outline"}
            className="min-h-12"
            onClick={onToggleEditing}
            disabled={busy}
          >
            {editing ? (
              <>
                <X className="mr-1 size-4" />
                Готово
              </>
            ) : (
              <>
                <Pencil className="mr-1 size-4" />
                Изменить состав
              </>
            )}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
